import React from 'react';
import { MessageSquare, Facebook, Instagram, Twitter } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export function ContactSection() {
  const { t } = useLanguage();

  const contactInfo = [
    {
      icon: Facebook,
      title: 'Facebook',
      content: 'AI-losofy',
      href: 'https://www.facebook.com/profile.php?id=61572070054049&sk=about'
    },
    {
      icon: Instagram,
      title: 'Instagram',
      content: '@jerofur',
      href: 'https://www.instagram.com/jerofur/'
    },
    {
      icon: Twitter,
      title: 'X (Twitter)',
      content: '@jerryFurt',
      href: 'https://x.com/jerryFurt',
      className: 'w-8 h-8'
    },
    {
      icon: MessageSquare,
      title: 'WhatsApp',
      content: '+54 9 11 6803 2436',
      href: 'https://wa.me/5491168032436'
    }
  ];

  return (
    <section id="contact" className="bg-white py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            {t('contact.heading')}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {t('contact.subheading')}
          </p>
        </div>

        {/* Contact cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {contactInfo.map((info, index) => (
            <a
              key={index}
              href={info.href}
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-gray-50 rounded-xl p-6 hover:bg-primary hover:text-white transition-all duration-300"
              aria-label={info.icon === Twitter ? "Follow on X (Twitter)" : undefined}
            >
              <div className="flex flex-col items-center text-center">
                <info.icon
                  className={`mb-4 text-primary group-hover:text-white transition-colors duration-300 ${
                    info.className || 'h-8 w-8'
                  }`}
                />
                <h3 className="text-lg font-semibold mb-2">{info.title}</h3>
                <p className="text-gray-600 group-hover:text-white/90">
                  {info.content}
                </p>
              </div>
            </a>
          ))}
        </div>

        {/* Chatbot note */}
        <div className="mt-16 text-center">
          <p className="text-gray-600">
            {t('contact.chatbot')}
          </p>
        </div>

        {/* Book reference (enhanced visibility) */}
        <div className="mt-16 text-center">
          <p className="text-xs uppercase tracking-widest text-gray-500 mb-3">
            {t('contact.founderBook')}
          </p>
          <a
            href="https://www.amazon.com/dp/B0G8T84PZR"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block text-lg font-semibold text-primary hover:underline"
          >
            {t('contact.bookTitle')}
          </a>
          <p className="mt-1 text-sm text-gray-500">
            {t('contact.bookAvailable')}
          </p>
        </div>

      </div>
    </section>
  );
}
